import React from "react";

import styled from "styled-components";

export const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

`;

export const Content = styled.div`
    width: 90%;
    flex: 1;
    display: flex;
    flex-direction: column;
`;

function MainContent({ children, style, ...props }) {
  return (
    <Container>
      <Content style={style}>
        {children}
      </Content>
    </Container>
  )
}

export default MainContent
